import { Alert, CircularProgress, Modal, Snackbar, Box, FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { WhiteInput } from "../../../components/Inputs/InputText";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import servConsultaPrevia from "../../../services/login/servConsultaPrevia";
import styles from "./ArquivamentoSolic.module.css";


const ArquivamentoSolic = ({ setOpenPopup, recordForEdit, pesquisar }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [arquivamentoSolicitacao, setArquivamentoSolicitacao] = useState(null);

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    useEffect(() => {
        const recuperarArquivamentoSolicitacao = async () => {
            try {
                setIsLoading(true);
                
                let dados = await servConsultaPrevia.RecuperarArquivamento(recordForEdit?.Id || recordForEdit?.row?.Id);
                
                setIsLoading(false);

                formatarData(dados);
                
                dados.Content.TipoResponsavelArquivamento = setarTipoArquivador(dados.Content.TipoResponsavelArquivamento);
                setArquivamentoSolicitacao(dados.Content);
            } catch (err) {
                setIsLoading(false);
                setErrorMessage(err.Message);
                setOpenErrorWindow(true);
            }
        }

        recuperarArquivamentoSolicitacao();
    }, [recordForEdit]);

    const formatarData = (dados) => {
        let dataArquivamentoAux = dados.Content.DataArquivamento;

        dataArquivamentoAux = parse(dataArquivamentoAux, 'dd/MM/yyyy HH:mm:ss', new Date());

        dados.Content.DataArquivamento = dataArquivamentoAux;
    }

    const setarTipoArquivador = (tipo) => {
        let txtTipo = "";

        switch (tipo) {
            case 1:
                txtTipo = "Responsável técnico"
                break;
            case 2:
                txtTipo = "Analista de projetos"
                break;
            default:
                break;
        }

        return txtTipo;
    }
    
    return (
        <div style={{
            width: "100%",
            minWidth: 600,
            height: "100%"
        }}>
            <div>
                <FormControl variant="outlined" style={{ margin: '5px 0px 20px 35px', width: "35%" }}>
                    <InputLabel shrink style={{ color: "#B8B8B8" }} >
                        Data de arquivamento
                    </InputLabel>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                        <DatePicker 
                            fullWidth
                            inputFormat="dd/MM/yyyy"
                            value={arquivamentoSolicitacao?.DataArquivamento}
                            readOnly={true}
                            renderInput={({ inputRef, inputProps, InputProps }) => (
                                <>
                                    <WhiteInput ref={inputRef}  {...inputProps} sx={{color: "#fff"}} />
                                    <span style={{ position: "absolute", top: 38, right: 15, color: "white", svg: "white", input: "white", label: "white" }}>
                                        {InputProps?.endAdornment}
                                    </span>
                                </>
                            )}
                        />
                    </LocalizationProvider>
                </FormControl>
            </div>
            <div className={styles.inputContainerUnique}>
                <FormControl variant="outlined" style={{ margin: '5px 0px 20px 35px', width: "90%" }}>
                    <InputLabel shrink style={{ color: "#B8B8B8" }} >
                        Arquivador
                    </InputLabel>
                    <WhiteInput 
                        fullWidth
                        type="text"
                        value={arquivamentoSolicitacao?.TipoResponsavelArquivamento}
                        readOnly={true}
                    />
                </FormControl>
            </div>
            <div className={styles.inputContainerUnique}>
                <FormControl variant="outlined" style={{ margin: '5px 0px 20px 35px', width: "90%" }}>
                    <InputLabel shrink style={{ color: "#B8B8B8" }} >
                        Usuário
                    </InputLabel>
                    <WhiteInput 
                        fullWidth
                        type="text"
                        value={arquivamentoSolicitacao?.Usuario}
                        readOnly={true}
                    />
                </FormControl>
            </div>
            <div className={styles.inputContainerUnique}>
                <FormControl variant="outlined" style={{ margin: '5px 0px 20px 35px', width: "90%" }}>
                    <InputLabel shrink style={{ color: "#B8B8B8" }} >
                        Motivo
                    </InputLabel>
                    <WhiteInput 
                        multiline
                        minRows={4}
                        fullWidth
                        type="text"
                        value={arquivamentoSolicitacao?.Descricao}
                        readOnly={true}
                    />
                </FormControl>
            </div>
            <div style={{
                margin: "25px 40px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px"
            }}>
                <BlueHoverButton onClick={() => setOpenPopup(false)}>Fechar</BlueHoverButton>
            </div>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    );
}

export { ArquivamentoSolic };